class localStorageService {
    ls = window.localStorage

    setItem(key, value) {
        value = JSON.stringify(value)
        this.ls.setItem(key, value)
        return true
    }

    getItem(key) {
        let value = this.ls.getItem(key)
        try {
            return JSON.parse(value)
        } catch (e) {
            return null
        }
    }
    removeItem(key) {
        this.ls.removeItem(key)
    }

}

const ls = new localStorageService()

export default ls

export const getStoredAuthToken = () => ls.getItem('accessToken');
export const getStoredUser = () => ls.getItem('user');

export const storeAuthToken = (token) => ls.setItem('accessToken', token);
export const storeUserData = (user) => ls.setItem('user', JSON.stringify(user));

export const removeStoredAuthToken = () => { ls.removeItem('accessToken'); ls.removeItem('user') }

export const storeSettings = (settings) => ls.setItem('settings', JSON.stringify(settings));
export const getStoredSettings = () => ls.getItem('settings');